// @ts-nocheck
import loadRealTimePricing from "@insite/client-framework/Store/CommonHandlers/LoadRealTimePricing";
import { getSession } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getProductState } from "@insite/client-framework/Store/Data/Products/ProductsSelectors";
import {
    chain,
    SetProductInfo,
} from "@insite/client-framework/Store/Pages/ProductDetails/Handlers/UpdateVariantSelection";
import { dispatchProductDetailEvent } from "@store/Framework/Services/AnalyticsService";
import { addToChainAfter } from "@toolkit/Modules/client-framework/HandlerCreator";

addToChainAfter(chain, SetProductInfo, props => {
    const { productInfo, selectedProductId: productId } = props;
    if (!productInfo || !productId) {
        return;
    }
    // Starter Custom Code - >
    const state = props.getState();
    const session = getSession(state);
    const productState = getProductState(state, props.productInfo?.productId ?? undefined);
    const isAuthenticated = session && (session.isAuthenticated || session.rememberMe) && !session.isGuest;

    const productDetailEvent = (pricingProps?: any) => {
        dispatchProductDetailEvent(productState.value, pricingProps);
    };

    if (!isAuthenticated) {
        productDetailEvent();
    }
    // <-- Starter Custom Code

    props.dispatch(
        loadRealTimePricing({
            productPriceParameters: [productInfo],
            onSuccess: realTimePricing => {
                const pricing = realTimePricing.realTimePricingResults!.find(
                    o => o.productId === productInfo.productId,
                );
                // Starter Custom Code - >
                if (isAuthenticated) {
                    productDetailEvent(realTimePricing.realTimePricingResults);
                }
                // <-- Starter Custom Code
                if (pricing) {
                    props.dispatch({
                        type: "Pages/ProductDetails/CompleteLoadRealTimePricing",
                        pricing,
                    });
                } else {
                    props.dispatch({
                        type: "Pages/ProductDetails/FailedLoadRealTimePricing",
                        productId,
                    });
                }
            },
            onError: () => {
                props.dispatch({
                    type: "Pages/ProductDetails/FailedLoadRealTimePricing",
                    productId,
                });
            },
            onComplete(realTimePricingProps) {
                if (realTimePricingProps.apiResult) {
                    this.onSuccess?.(realTimePricingProps.apiResult);
                } else if (realTimePricingProps.error) {
                    this.onError?.(realTimePricingProps.error);
                }
            },
        }),
    );
});
